'use strict';

var _ = require('lodash');
var CommonsConfigController = function CommonsConfigController($rootScope, $scope, $state, userSecureService, deleteTokenService, $cookies, $window, $http, bootstrapFeaturesService, idleService, featureToggleService, globalNotificationsDataService) {
  var ApplicationNameTitles = [{
    appName: 'REVENUE_OPTIMIZER',
    title: 'Revenue Optimizer'
  }, {
    appName: 'FARES_OPTIMIZER',
    title: 'Pricing Suite'
  }, {
    appName: 'DYNAMIC_AVAILABILITY',
    title: 'Dynamic Availability'
  }, {
    appName: 'PRICING_SUITE',
    title: 'Pricing Suite'
  }];
  $scope.appTitle = getAppTitle();
  $scope.globalNotificationsTotalNumber = 0;

  // Getting page name from current state (used as identifier in contextual help)
  $scope.currentPageName = _.trimStart($state.current.name, 'app.');

  // Watching for change in current state
  $rootScope.$on('$stateChangeStart', function (event, toState) {
    $scope.currentPageName = _.trimStart(toState.name, 'app.');
  });
  $scope.currentUserName = userSecureService.getCurrentUser().getDisplayName();
  $scope.logout = function () {
    deleteTokenService.deleteToken().then(function (response) {
      var newLocation = response && response.headers && response.headers('location');
      $window.sessionStorage.clear();
      ['iPlanetDirectoryPro', 'carrierCode'].forEach($cookies.remove);
      if (newLocation) {
        $window.location = newLocation;
        return;
      }
      $window.location.reload(true);
    });
  };
  $scope.$on('KeepaliveResponse', function (e, response) {
    if (response.status === -1) {
      $scope.logout();
    }
  });
  $scope.$on('IdleTimeout', function () {
    $scope.logout();
  });
  $scope.$on('brush-filter:filterApplied:updateToolbar', updateGlobalNotificationsNumber);
  function updateGlobalNotificationsNumber() {
    globalNotificationsDataService.getTotalAlertsNumber().then(function (totalNumber) {
      if (totalNumber > 0) {
        $scope.globalNotificationsTotalNumber = 1;
      }
    });
  }
  function getAppTitle() {
    var applicationMap = [featureEnabled('REVENUE_OPTIMIZER'), featureEnabled('FARES_OPTIMIZER'), featureEnabled('DYNAMIC_AVAILABILITY'), featureEnabled('PRICING_SUITE')];
    var enabledApps = _.filter(applicationMap, {
      enabled: true
    });
    if (enabledApps.length > 1 || enabledApps.length == 0) {
      return 'Revenue Optimization';
    } else {
      return _.find(ApplicationNameTitles, {
        'appName': enabledApps[0].featureName
      }).title;
    }
  }
  function featureEnabled(featureName) {
    if (featureToggleService.isEnabled(featureName)) {
      return {
        featureName: featureName,
        enabled: true
      };
    } else {
      return {
        featureName: featureName,
        enabled: false
      };
    }
  }
  idleService.watch();
};
CommonsConfigController.$inject = ['$rootScope', '$scope', '$state', 'UserSecureService', 'DeleteTokenService', '$cookies', '$window', '$http', 'BootstrapFeaturesService', 'Idle', 'FeatureToggleService', 'GlobalNotificationsDataService'];
module.exports = CommonsConfigController;